import { CustomApplicationActions } from "@MasterBluePrint/Store/CustomApplicationState";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

interface Parameter {
    isBypassingPiyoviAddressValidation: boolean;
}

type HandlerType = Handler<Parameter, DispatchProp<CustomApplicationActions>>;

export const DispatchSetByPassPiyoviAddressValidation: HandlerType = props => {
    props.dispatch({
        type: "Components/CustomCheckoutShipping/SetBypassingPiyoviAddressValidation",
        isBypassingPiyoviAddressValidation: props.parameter.isBypassingPiyoviAddressValidation,
    });
};

export const chain = [
    DispatchSetByPassPiyoviAddressValidation
];

const setByPassPiyoviAddressValidation = createHandlerChainRunner(chain, "SetByPassPiyoviAddressValidation");
export default setByPassPiyoviAddressValidation;
